module.exports = __webpack_public_path__ + "img/hero-image-02-fi.752de92f.png";